/** @format */

import {ComposedChart, ResponsiveContainer, Scatter} from 'recharts';

import {Shape} from './Shape';

import {SCATTER_HEIGHT} from '../../const';
import {MarginOptions} from '../../model/common';
import {CommonChartData} from '../../model/charts';

interface Props {
  data: CommonChartData[];
  syncId: string;
  margin?: MarginOptions;
}

const ScatterChart = ({data, syncId, margin}: Props) => {
  return (
    <ResponsiveContainer height={SCATTER_HEIGHT}>
      <ComposedChart data={data} syncId={syncId} margin={margin}>
        <Scatter dataKey='primary' shape={<Shape />} />
      </ComposedChart>
    </ResponsiveContainer>
  );
};
export {ScatterChart};
